<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import TableOverview from "../components/TableOverview.vue";
import modal from "@/ui/components/modal.vue";
import { onBeforeMount, Ref, ref } from "vue";
import { useApiClient } from "@/api/client";
import { toastApiResult } from "@/toaster";
import router from "@/router/router";
import {
	required,
	maxLength,
	titleInputRules,
} from "@/ui/validation/validationRules";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const breadcrumbs = [
	{
		title: "Roles",
		disabled: true,
		to: "/roles",
	},
];

const newRole: Ref<App.Data.RoleDO> = ref();
const loadNewRole = async () => {
	const response = await useApiClient("roles").getNewRole();
	if (response.isOk()) {
		newRole.value = response.value;
	}
};

onBeforeMount(() => {
	loadNewRole();
});

const closeModal = () => {
	isNewRoleVisible.value = false;
	loadNewRole();
};

const submitRole = async () => {
	const response = await toastApiResult(
		useApiClient("roles").createRole(newRole.value)
	);
	if (response.isOk()) {
		closeModal();
		router.push({
			path: `/roles/edit/${response.value.uuid}`,
		});
	}
};

const setNameClean = () => {
	newRole.value.name_clean = newRole.value.name
		.replace(/(^-+|[^a-zA-Z0-9/_| -]+|-+$)/g, "")
		.toLowerCase()
		.replace(/[/_| -]+/g, "_");
};

const search = ref("");
const isNewRoleVisible: Ref<boolean> = ref(false);
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" />
	<v-card class="pa-5" elevation="4">
		<div class="d-flex flex-nowrap mb-5">
			<v-text-field
				v-model="search"
				class="mr-3"
				prepend-inner-icon="mdi-magnify"
				:label="t('roles.overview.search')"
				variant="filled"
				single-line
				hide-details
			/>
			<v-btn
				variant="elevated"
				prepend-icon="fa: fa-light fa-plus"
				height="48"
				@click="isNewRoleVisible = true"
			>
				{{ t("roles.overview.addRole") }}
			</v-btn>
		</div>

		<modal
			v-model:visible="isNewRoleVisible"
			:title="t('roles.overview.modal.title')"
			icon="fa: fa-light fa-people-group"
			@submit="submitRole"
		>
			<v-text-field
				v-model="newRole.name"
				:label="t('roles.overview.modal.inputName')"
				clearable
				@keyup="setNameClean()"
				:rules="titleInputRules(t)"
			/>

			<v-textarea
				v-model="newRole.description"
				:label="t('roles.overview.modal.inputDescription')"
				:rules="[required(t), maxLength(t, 255)]"
				maxlength="255"
				auto-grow
				counter
				rows="3"
			/>
		</modal>

		<table-overview :search="search" />
	</v-card>
</template>

<style lang="scss">
.card-border-right {
	border-left: 50px solid rgb(var(--v-theme-borderColor));
}
</style>
